import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { ChoiceFieldset, Box } from '@primer/components';
import { CheckIcon, XIcon, AlertIcon } from '@primer/octicons-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`A `}<inlineCode parentName="p">{`ChoiceFieldset`}</inlineCode>{` is a controlled component that is used to render a related set of checkbox or radio inputs.`}</p>
    <h2>{`Deprecation`}</h2>
    <p>{`Use `}<a parentName="p" {...{
        "href": "/CheckboxGroup"
      }}>{`CheckboxGroup`}</a>{` or `}<a parentName="p" {...{
        "href": "/RadioGroup"
      }}>{`RadioGroup`}</a>{` instead.`}</p>
    <h2>{`Examples`}</h2>
    <h3>{`Basic`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<ChoiceFieldset>
  <ChoiceFieldset.Legend>Color mode</ChoiceFieldset.Legend>
  <ChoiceFieldset.List>
    <ChoiceFieldset.Item value="dark">Dark</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="hc-dark">High-contrast dark</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="light">Light</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="hc-light">High-contrast light</ChoiceFieldset.Item>
  </ChoiceFieldset.List>
</ChoiceFieldset>
`}</code></pre>
    <h3>{`Using an onSelect handler`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline deprecated",
        "live": true,
        "noinline": true,
        "deprecated": true
      }}>{`const WithOnSelectHandler = () => {
  const [selectedChoices, setSelectedChoices] = React.useState([])
  const choices = [
    {
      value: 'figma',
      displayName: 'Figma library',
      description: 'The Figma file where we have Figma symbols and light documentation',
    },
    {
      value: 'css',
      displayName: 'Primer CSS',
      description: 'The OG. A CSS library with utility styles and component styles',
    },
    {
      value: 'react',
      displayName: 'Primer React components',
      description: 'The React component library that these docs belong to',
    },
    {
      value: 'viewcomponents',
      displayName: 'Primer ViewComponents',
      description: 'The Rails and Web Components implementation of our components',
    },
  ]

  return (
    <>
      <ChoiceFieldset
        onSelect={selectedValues => {
          setSelectedChoices(selectedValues)
        }}
        selected={selectedChoices}
      >
        <ChoiceFieldset.Legend>Prefered Primer component interface</ChoiceFieldset.Legend>
        <ChoiceFieldset.Description>
          Your choice won't be used for anything, this is just a React example
        </ChoiceFieldset.Description>
        <ChoiceFieldset.List>
          {choices.map(choice => (
            <ChoiceFieldset.Item value={choice.value} key={choice.value}>
              <Item.Label>{choice.displayName}</Item.Label>
              <Item.Caption>{choice.description}</Item.Caption>
            </ChoiceFieldset.Item>
          ))}
        </ChoiceFieldset.List>
      </ChoiceFieldset>
      {selectedChoices.length ? (
        <Box mt={2}>
          <em>{choices.find(choice => choice.value === selectedChoices[0]).displayName}</em> is your favorite? Ours too.
        </Box>
      ) : null}
    </>
  )
}

render(<WithOnSelectHandler />)
`}</code></pre>
    <h3>{`Checkbox group`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<ChoiceFieldset>
  <ChoiceFieldset.Legend>Prefered Primer component interface</ChoiceFieldset.Legend>

  <ChoiceFieldset.List selectionVariant="multiple">
    <ChoiceFieldset.Item value="figma">Figma library</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="css">Primer CSS</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="react">Primer React components</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="viewcomponents">Primer ViewComponents</ChoiceFieldset.Item>
  </ChoiceFieldset.List>
</ChoiceFieldset>
`}</code></pre>
    <h3>{`Disabled`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<ChoiceFieldset disabled>
  <ChoiceFieldset.Legend>Color mode</ChoiceFieldset.Legend>
  <ChoiceFieldset.List>
    <ChoiceFieldset.Item value="dark">Dark</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="hc-dark">High-contrast dark</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="light">Light</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="hc-light">High-contrast light</ChoiceFieldset.Item>
  </ChoiceFieldset.List>
</ChoiceFieldset>
`}</code></pre>
    <h3>{`Required`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<ChoiceFieldset required>
  <ChoiceFieldset.Legend>Color mode</ChoiceFieldset.Legend>
  <ChoiceFieldset.List>
    <ChoiceFieldset.Item value="dark">Dark</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="hc-dark">High-contrast dark</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="light">Light</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="hc-light">High-contrast light</ChoiceFieldset.Item>
  </ChoiceFieldset.List>
</ChoiceFieldset>
`}</code></pre>
    <h3>{`With pre-selected choices`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<ChoiceFieldset selected={['figma', 'react']}>
  <ChoiceFieldset.Legend>Prefered Primer component interface</ChoiceFieldset.Legend>

  <ChoiceFieldset.List selectionVariant="multiple">
    <ChoiceFieldset.Item value="figma">Figma library</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="css">Primer CSS</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="react">Primer React components</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="viewcomponents">Primer ViewComponents</ChoiceFieldset.Item>
  </ChoiceFieldset.List>
</ChoiceFieldset>
`}</code></pre>
    <h3>{`With validation`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline deprecated",
        "live": true,
        "noinline": true,
        "deprecated": true
      }}>{`const choices = [
  {
    value: 'figma',
    displayName: 'Figma library',
    description: 'The Figma file where we have Figma symbols and light documentation',
  },
  {
    value: 'css',
    displayName: 'Primer CSS',
    description: 'The OG. A CSS library with utility styles and component styles',
  },
  {
    value: 'react',
    displayName: 'Primer React components',
    description: 'The React component library that these docs belong to',
  },
  {
    value: 'viewcomponents',
    displayName: 'Primer ViewComponents',
    description: 'The Rails and Web Components implementation of our components',
  },
]

const ChoiceFieldsetWithValidation = () => {
  const [selectedChoices, setSelectedChoices] = React.useState([])
  const [validationResult, setValidationResult] = React.useState()

  React.useEffect(() => {
    if (selectedChoices.length && selectedChoices.length > 2) {
      setValidationResult('tooManySelections')
    } else {
      setValidationResult(undefined)
    }
  }, [selectedChoices])

  return (
    <ChoiceFieldset
      name="radioGroup"
      onSelect={selectedValues => {
        setSelectedChoices(selectedValues)
      }}
      validationMap={{tooManySelections: 'error'}}
      validationResult={validationResult}
      selected={selectedChoices}
    >
      <ChoiceFieldset.Legend>Prefered Primer component interface</ChoiceFieldset.Legend>
      <ChoiceFieldset.Description>Pick your top two</ChoiceFieldset.Description>

      <ChoiceFieldset.List selectionVariant="multiple">
        {choices.map(choice => (
          <ChoiceFieldset.Item value={choice.value}>
            <Item.Label>{choice.displayName}</Item.Label>
            <Item.Caption>{choice.description}</Item.Caption>
          </ChoiceFieldset.Item>
        ))}
      </ChoiceFieldset.List>

      <ChoiceFieldset.Validation validationKey="tooManySelections">
        Only two selections are allowed
      </ChoiceFieldset.Validation>
    </ChoiceFieldset>
  )
}

render(<ChoiceFieldsetWithValidation />)
`}</code></pre>
    <h3>{`A visually hidden legend`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<ChoiceFieldset>
  <ChoiceFieldset.Legend visuallyHidden>Color mode</ChoiceFieldset.Legend>
  <ChoiceFieldset.List>
    <ChoiceFieldset.Item value="dark">Dark</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="hc-dark">High-contrast dark</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="light">Light</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="hc-light">High-contrast light</ChoiceFieldset.Item>
  </ChoiceFieldset.List>
</ChoiceFieldset>
`}</code></pre>
    <h3>{`With a ChoiceFieldset.Description`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<ChoiceFieldset>
  <ChoiceFieldset.Legend>Notification preferences</ChoiceFieldset.Legend>
  <ChoiceFieldset.Description>
    Your selection will affect notifications sent to your email and mobile device
  </ChoiceFieldset.Description>

  <ChoiceFieldset.List>
    <ChoiceFieldset.Item value="all">
      <Item.LeadingVisual>
        <CheckIcon />
      </Item.LeadingVisual>
      <Item.Label>All notifications</Item.Label>
      <Item.Caption>Every possible notification</Item.Caption>
    </ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="relevant">
      <Item.LeadingVisual>
        <AlertIcon />
      </Item.LeadingVisual>
      <Item.Label>Relevant notifications</Item.Label>
      <Item.Caption>Only the ones you'll care about</Item.Caption>
    </ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="none">
      <Item.LeadingVisual>
        <XIcon />
      </Item.LeadingVisual>
      <Item.Label>No notifications</Item.Label>
      <Item.Caption>Notifications won't be sent</Item.Caption>
    </ChoiceFieldset.Item>
  </ChoiceFieldset.List>
</ChoiceFieldset>
`}</code></pre>
    <h3>{`With one disabled item`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<ChoiceFieldset>
  <ChoiceFieldset.Legend>Color mode</ChoiceFieldset.Legend>
  <ChoiceFieldset.List>
    <ChoiceFieldset.Item disabled value="dark">
      Dark
    </ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="hc-dark">High-contrast dark</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="light">Light</ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="hc-light">High-contrast light</ChoiceFieldset.Item>
  </ChoiceFieldset.List>
</ChoiceFieldset>
`}</code></pre>
    <h3>{`Items with a caption and a leading visual`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<ChoiceFieldset>
  <ChoiceFieldset.Legend>Notification preferences</ChoiceFieldset.Legend>

  <ChoiceFieldset.List>
    <ChoiceFieldset.Item value="all">
      <Item.LeadingVisual>
        <CheckIcon />
      </Item.LeadingVisual>
      <Item.Label>All notifications</Item.Label>
      <Item.Caption>Every possible notification</Item.Caption>
    </ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="relevant">
      <Item.LeadingVisual>
        <AlertIcon />
      </Item.LeadingVisual>
      <Item.Label>Relevant notifications</Item.Label>
      <Item.Caption>Only the ones you'll care about</Item.Caption>
    </ChoiceFieldset.Item>
    <ChoiceFieldset.Item value="none">
      <Item.LeadingVisual>
        <XIcon />
      </Item.LeadingVisual>
      <Item.Label>No notifications</Item.Label>
      <Item.Caption>Notifications won't be sent</Item.Caption>
    </ChoiceFieldset.Item>
  </ChoiceFieldset.List>
</ChoiceFieldset>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`ChoiceFieldset`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}{`*`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ChoiceFieldset.Legend`}</inlineCode>{`, `}<inlineCode parentName="td">{`ChoiceFieldset.Description`}</inlineCode>{`, `}<inlineCode parentName="td">{`ChoiceFieldset.List`}</inlineCode>{`, `}<inlineCode parentName="td">{`ChoiceFieldset.Validation`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The list of choices and contextual information`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`disabled`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether the fieldset is NOT ready for user input`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The unique identifier for this fieldset. Used to associate the validation text with the fieldset `}<br />{` If an ID is not passed, one will be automatically generated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The unique identifier used to associate radio inputs with eachother `}<br />{` If a name is not passed and the fieldset renders radio inputs, a name will be automatically generated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`onSelect`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`(selectedValues?: string[]) => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The callback that is called when a user toggles a choice on or off`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`required`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether this field must have a value for the user to complete their task`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`selected`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The selected values`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`validationMap`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Record<string, 'error' \\| 'success'>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A map of validation statuses and their associated validation keys. When one of the validation keys is passed to the `}<inlineCode parentName="td">{`validationResult`}</inlineCode>{` prop, the associated validation message will be rendered in the correct style`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`validationResult`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`keyof validationMap`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The key of the validation message to show`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`ChoiceFieldset.Legend`}</h3>
    <p>{`A title for the set of choices. A `}<inlineCode parentName="p">{`ChoiceFieldset.Legend`}</inlineCode>{` must be passed, but it may be visually hidden.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`visuallyHidden`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether to visually hide the fieldset legend`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`ChoiceFieldset.List`}</h3>
    <p>{`The list choices are rendered in.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}{`*`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ChoiceFieldset.Item`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The choices that render as a checkbox or radio field`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`selectionVariant`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`'single'\\|'multiple'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether multiple items or a single item can be selected`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`ChoiceFieldset.Item`}</h3>
    <p>{`Renders a choice to the list as a checkbox or radio field.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}{`*`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ChoiceFieldset.Caption`}</inlineCode>{`, `}<inlineCode parentName="td">{`ChoiceFieldset.Label`}</inlineCode>{`, `}<inlineCode parentName="td">{`ChoiceFieldset.LeadingVisual`}</inlineCode>{`, `}<inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The parts that make up the checkbox or radio field used to select the choice. `}<br />{` If you `}<strong parentName="td">{`only`}</strong>{` need a label, it's fine to pass in a string or JSX instead of wrapping it in the `}<inlineCode parentName="td">{`Item.Label`}</inlineCode>{` component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`value`}{`*`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The value that is being selected`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`disabled`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Whether the field is ready for user input`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The unique identifier for this field. Used to associate the label, validation text, and caption text. `}<br />{` If an ID is not provided, one will be automatically generated.`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`ChoiceFieldset.Description`}</h3>
    <p>{`A `}<inlineCode parentName="p">{`ChoiceFieldset.Description`}</inlineCode>{` may be used to render hint text if this list needs additional context to guide a user to make their selection`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}{`*`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The description content`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`ChoiceFieldset.Validation`}</h3>
    <p>{`If the user's selection has been flagged during validation, `}<inlineCode parentName="p">{`ChoiceFieldset.Validation`}</inlineCode>{` may be used to render contextual validation information to help the user complete their task`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}{`*`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The validation message`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`validationKey`}{`*`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`–`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`When this matches the `}<inlineCode parentName="td">{`validationResult`}</inlineCode>{` prop on the parent `}<inlineCode parentName="td">{`ChoiceFieldset`}</inlineCode>{` component, this validation component will be rendered`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: true,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/ChoiceInputField"
        }}>{`ChoiceInputField`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/Checkbox"
        }}>{`Checkbox`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/Radio"
        }}>{`Radio`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      